import { POSITION_IN_COLLECTION_EVENT } from './use_widget_layout'

export const LAZY_WIDGET_MEMBER_ID = -1
export const LAUNCHER_HEIGHT =
  // eslint-disable-next-line
  // @ts-ignore
  window.speakeasySettings?.launcherSize === 'sm' ? 124 : 130
export const LAUNCHER_WIDTH =
  // eslint-disable-next-line
  // @ts-ignore
  window.speakeasySettings?.launcherSize === 'sm' ? 134 : 140
export enum WIDGET_LAYOUT {
  FLOATING = 'FLOATING',
  EMBEDDED = 'EMBEDDED',
  WIDGET = 'WIDGET',
  CONTACT_FORM = 'CONTACT_FORM',
  FULLSCREEN = 'FULLSCREEN',
  WIDGET_MAXIMISED = 'WIDGET_MAXIMISED',
  WIDGET_MINIMISED = 'WIDGET_MINIMISED',
  FLOATING_CLOSED = 'FLOATING_CLOSED',
}

const DEFAULT_VIDEO_HEIGHT = 608
export const EMBEDDED_IFRAME_HEIGHT = DEFAULT_VIDEO_HEIGHT + 3 * 2 // plus border width

const FLOATING_VIDEO_HEIGHT = 256
export const FLOATING_IFRAME_HEIGHT = FLOATING_VIDEO_HEIGHT + 30 * 2 // plus margin

const WIDGET_VIDEO_HEIGHT = 608
export const WIDGET_IFRAME_HEIGHT = WIDGET_VIDEO_HEIGHT + LAUNCHER_HEIGHT + 30

export const SPEAKEASY_CONTAINER_ID = 'speakeasy-container'

export const isFirstInCollection =
  !window.frameElement?.parentElement?.previousSibling?.dataset?.hasOwnProperty('widget')
export const isLastInCollection =
  !window.frameElement?.parentElement?.nextSibling?.dataset?.hasOwnProperty('widget')

export const embeddedContainer = window.frameElement?.closest(
  '#speakeasy-embedded-container',
) as HTMLElement
export const dialogElement = window.frameElement?.closest(
  'dialog',
) as HTMLDialogElement
export const collectionScrollBox =  window.frameElement?.closest(
  '.widget-scrollbar-none',
) as HTMLDivElement
export const iframeElements = Array.from(
  dialogElement?.getElementsByTagName('iframe') || [],
)

export const selectPlayer = (offset: number) => {
  let indexOfSelected = iframeElements.indexOf(window.frameElement) + offset
  if (indexOfSelected === -1) {
    indexOfSelected = iframeElements.length - 1
  }
  indexOfSelected = indexOfSelected % iframeElements.length
  for (let i = 0; i < iframeElements.length; i++) {
    iframeElements[i].contentWindow.dispatchEvent(
      new CustomEvent(POSITION_IN_COLLECTION_EVENT, {
        detail: {
          position: indexOfSelected * -1 + i,
        },
      }),
    )
  }
}

export const COLLECTION_MUTED_EVENT = 'COLLECTION_MUTED'
